<template>
  <van-popup v-model="popShow" position="bottom" :close-on-click-overlay="false">
    <div class="filter_popup">
      <img
        :class="$store.state.isMirroring && 'mirror'"
        class="close"
        src="@/assets/close.png"
        @click="popShow = false"
      />
      <div class="title">{{ $t('filters.time') }}</div>
      <div v-if="contentShow" class="input_group">
        <CommonInput
          class="date_input"
          v-model="beginTime"
          :placeholder="$t('filters.start')"
          theme="white"
          inputmode="numeric"
          :auto-focus="true"
          readonly
          :on-focus="() => setCurTime('BEGIN')"
        >
        </CommonInput>
        <div class="split"></div>
        <CommonInput
          class="date_input"
          v-model="endTime"
          :placeholder="$t('filters.end')"
          theme="white"
          inputmode="numeric"
          readonly
          :auto-focus="false"
          :on-focus="() => setCurTime('END')"
        >
        </CommonInput>
      </div>
      <van-datetime-picker
        v-if="contentShow && curSetTime === 'BEGIN'"
        v-model="currentDate"
        class="date_picker"
        type="date"
        :show-toolbar="false"
        :min-date="minDate"
        :max-date="endTimeDate"
        :item-height="60"
        :visible-item-count="3"
        @change="onChange"
      />
      <van-datetime-picker
        v-if="contentShow && curSetTime === 'END'"
        v-model="currentDate"
        class="date_picker"
        type="date"
        :show-toolbar="false"
        :min-date="beginTimeDate"
        :max-date="maxDate"
        :item-height="60"
        :visible-item-count="3"
        @change="onChange"
      />
      <div class="bottom_btn_group">
        <div class="bottom_btn cancel" @click="resetTime">{{ $t('filters.reset') }}</div>
        <div class="bottom_btn confirm" @click="setTime">{{ $t('common.confirm') }}</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import moment from 'moment'
import CommonInput from '@/components/CommonInput'

export default {
  name: 'TransactionDateFilter',
  components: {
    CommonInput
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    curBeginTime: {
      type: String,
      required: true
    },
    curEndTime: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      popShow: false,
      contentShow: false,
      currentDate: new Date(moment().format('YYYY-MM-DD')),
      beginTime: moment().subtract(6, 'months').format('YYYY-MM-DD'),
      endTime: moment().format('YYYY-MM-DD'),
      beginTimeDate: new Date(moment().subtract(6, 'months').format('YYYY-MM-DD')),
      endTimeDate: new Date(moment().format('YYYY-MM-DD')),
      curSetTime: 'BEGIN',
      minDate: new Date(moment().subtract(6, 'months').format('YYYY-MM-DD')),
      maxDate: new Date(moment().format('YYYY-MM-DD'))
    }
  },
  watch: {
    value(val) {
      this.popShow = val
      // 弹框打开时，初始化时间
      if (val) {
        this.curSetTime = 'BEGIN'
        this.currentDate = this.curBeginTime
          ? new Date(moment(this.curBeginTime).format('YYYY-MM-DD'))
          : new Date(moment().subtract(6, 'months').format('YYYY-MM-DD'))
        this.beginTime = moment(this.currentDate).format('YYYY-MM-DD')
        this.beginTimeDate = new Date(moment(this.beginTime).format('YYYY-MM-DD'))
        this.endTime = this.curEndTime ? moment(this.curEndTime).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        this.endTimeDate = new Date(moment(this.endTime).format('YYYY-MM-DD'))
      }
    },
    popShow(val) {
      this.$emit('input', val)
      if (val) {
        this.contentShow = true
      } else {
        setTimeout(() => {
          this.contentShow = false
        }, 300)
      }
    }
  },
  methods: {
    resetTime() {
      this.beginTime = moment().subtract(6, 'months').format('YYYY-MM-DD')
      this.beginTimeDate = new Date(moment(this.beginTime).format('YYYY-MM-DD'))
      this.endTime = moment().format('YYYY-MM-DD')
      this.endTimeDate = new Date(moment(this.endTime).format('YYYY-MM-DD'))
    },
    setTime() {
      this.$emit('setTime', {
        beginTime: this.beginTime,
        endTime: this.endTime
      })
      this.popShow = false
    },
    setCurTime(type) {
      if (type === 'BEGIN') {
        if (!this.beginTime) {
          this.beginTime = moment().subtract(6, 'months').format('YYYY-MM-DD')
          this.beginTimeDate = new Date(moment(this.beginTime).format('YYYY-MM-DD'))
        }
        this.currentDate = new Date(moment(this.beginTime).format('YYYY-MM-DD'))
      } else if (type === 'END') {
        if (!this.endTime) {
          this.endTime = moment().format('YYYY-MM-DD')
          this.endTimeDate = new Date(moment(this.endTime).format('YYYY-MM-DD'))
        }
        this.currentDate = new Date(moment(this.endTime).format('YYYY-MM-DD'))
      }
      this.$nextTick(() => {
        console.log(this.currentDate)
        this.curSetTime = type
      })
    },
    onChange() {
      if (this.curSetTime === 'BEGIN') {
        this.beginTime = moment(this.currentDate).format('YYYY-MM-DD')
        this.beginTimeDate = new Date(moment(this.beginTime).format('YYYY-MM-DD'))
      } else if (this.curSetTime === 'END') {
        this.endTime = moment(this.currentDate).format('YYYY-MM-DD')
        this.endTimeDate = new Date(moment(this.endTime).format('YYYY-MM-DD'))
      }
    }
  }
}
</script>

<style scoped>
.filter_popup {
  width: 100%;
  padding: 0.24rem 0.2rem;
  background: #fff;
  border-radius: 0.16rem 0.16rem 0 0;
  min-height: 3rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.close {
  position: absolute;
  top: 0.24rem;
  right: 0.24rem;
  width: 0.24rem;
  height: 0.24rem;
}

.close.mirror {
  left: 0.24rem;
  right: auto;
}

.title {
  width: 100%;
  display: flex;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.28rem;
}

.input_group {
  margin-top: 0.12rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.split {
  width: 0.13rem;
  height: 0.02rem;
  background: #2f2f2f;
  margin: 0 0.2rem;
  flex-shrink: 0;
}

.date_picker {
  position: relative;
  overflow: hidden;
  width: 100%;
  margin: 0.2rem 0;
}

.bottom_btn_group {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
}

.bottom_btn {
  display: flex;
  width: 100%;
  padding: 0.13rem 0.24rem;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  border-radius: 0.08rem;
  border: 0.01rem solid #3fbb70;
  color: #3fbb70;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.16rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.24rem;
}

.bottom_btn.cancel {
  margin-inline-end: 0.12rem;
}

.bottom_btn.confirm {
  background: #3fbb70;
  color: #fff;
}
</style>

<style>
.date_picker .van-picker__frame {
  height: 0.6rem !important;
  background: linear-gradient(
    270deg,
    rgba(0, 255, 101, 0) 0%,
    rgba(7, 228, 94, 0.3) 40%,
    rgba(0, 255, 101, 0.3) 60%,
    rgba(0, 255, 101, 0) 100%
  );
}

.van-picker-column__item--selected {
  font-weight: 600 !important;
}

.date_input .input_area {
  text-align: center !important;
}

.date_input.focus .input_area {
  color: #3fbb70;
}
</style>



// WEBPACK FOOTER //
// src/components/Transaction/TransactionDateFilter.vue